function AdminDrivesController($scope, $state) { }
AdminDrivesController.$inject = ["$scope", "$state"];
export default AdminDrivesController;

